import { Dispatch, useReducer } from "react"

import { createTableReducer } from "./reducer"
import { RowSelectionKind, TableAction, TableState } from "./types"

export interface UseTableStateProps<T> {
  extractRowKey: (rowData: T) => string
  rowSelectionKind?: RowSelectionKind
  initialSelectedByKeys?: Map<string, T>
}

export function useTableState<T>({
  extractRowKey,
  rowSelectionKind,
  initialSelectedByKeys,
}: UseTableStateProps<T>): [TableState<T>, Dispatch<TableAction<T>>] {
  const initialState: TableState<T> = {
    expandedGroups: new Set<string>(),
    selectedByKey: initialSelectedByKeys ?? new Map<string, T>(),
    lastClickedRowKey: "",
    isAllSelected: false,
  }

  const [state, dispatch] = useReducer(
    createTableReducer({ extractRowKey, rowSelectionKind }),
    initialState
  )
  return [state, dispatch]
}
